import { useState } from 'react';

import { initialFormInputs } from '../constants';
import {
  HandleChange,
  HandleInputChange,
  TerminationSimulationInputs,
} from '../types';

export const useFormInput = () => {
  const [form, setForm] =
    useState<TerminationSimulationInputs>(initialFormInputs);
  const [inputErrors, setInputErrors] = useState<Record<string, boolean>>({});

  const handleChange: HandleInputChange =
    (key: string) => (e: HandleChange) => {
      const value =
        e && typeof e === 'object' && 'target' in e ? e.target.value : e;
      setForm({ ...form, [key]: value });
      if (inputErrors[key]) {
        setInputErrors({ ...inputErrors, [key]: false });
      }
    };

  const getInputProps = (key: keyof TerminationSimulationInputs) => ({
    value:
      form[key] === undefined || form[key] === null ? '' : String(form[key]),
    onChange: handleChange(key),
  });

  return {
    getInputProps,
    form,
    errors: inputErrors,
    setErrors: setInputErrors,
  };
};
